import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/credit-edit-screen.module.scss';
import Loader from 'src/components/Loader';

import Form, { CreditFormData } from '../../components/CreditForm';
import { ICredit } from 'src/types/credit';
import RoleLayout from '../../../../../../components/layout/RoleLayout';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IServiceType } from '../../../../../../types/service-types';
import { IInvoice } from '../../../../../../types/invoice';
import { QueryParams } from '../../../../../../types/grid';
import { toast } from 'react-toastify';
import CaseEnum from '../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    credit: ICredit | null;
    inProgress: boolean;
    students: SelectObject[];
    vendors: SelectObject[];
    providers: SelectObject[];
    districts: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    invoices: Paginated<IInvoice>;
    valuesForm: Partial<CreditFormData>;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getInvoices: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}
export interface OwnProps extends RouteComponentProps<RouteParams> {
    history: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CreditEditScreen: FC<Props> = (props: Props) => {
    const {
        credit,
        match: {
            params: { id },
        },
        getStudents,
        getDistricts,
        getVendors,
        getServiceTypes,
        invoices,
        getInvoices,
        students,
        vendors,
        districts,
        providers,
        getProviders,
        serviceTypes,
        valuesForm,
        getData,
        inProgress,
    } = props;
    const [stateInvoice, setStateInvoice] = useState<any>({
        list: [],
        page: 1,
        invoiceIds: [],
        isFilterOn: false,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
        lastIds: [],
    });

    useEffect(() => {
        if (typeof invoices.totalPages === 'number' && credit ) {
            if (stateInvoice.withIds && !inProgress) {
                if (stateInvoice.invoiceIds.length) {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.invoiceIds);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];

                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                        isFilterOn: true,
                    });
                } else {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];

                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        invoiceIds: invoices.list,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                    });
                }
            } else {
                const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);
                const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                const uniq: ListType<IInvoice> = [...some];

                setStateInvoice({
                    ...stateInvoice,
                    ...invoices,
                    list: uniq,

                    inProgress: false,
                    withIds: true,
                });
            }

            if (!inProgress && !stateInvoice.isTwo && credit?.paymentInvoices.length) {
                const invs: any = [];

                credit.paymentInvoices.forEach((it: any) => {
                    invs.push(it?.invoice?.id);
                });

             if(JSON.stringify(invs) !== JSON.stringify(stateInvoice.lastIds)){

                    getInvoices({
                        page: 1,
                        itemsPerPage: 9000,
                        filters: {
                            id: invs,
                        },
                    });
                    setStateInvoice({
                        ...stateInvoice,
                        lastIds: invs
                    });
                }

            }
        }

        // eslint-disable-next-line
    }, [inProgress, stateInvoice.lastIds]);

    useEffect(() => {
        if (!credit || credit.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (credit?.id) {
            getStudents({
                page: 1,
                itemsPerPage: 9000,
            });

            getDistricts({
                page: 1,
                itemsPerPage: 1200,
            });
            getVendors({
                page: 1,
                itemsPerPage: 1200,
            });
            getProviders({
                page: 1,
                itemsPerPage: 1200,
            });
            getServiceTypes({
                page: 1,
                itemsPerPage: 1200,
            });
        }
        // eslint-disable-next-line
    }, [credit?.id, getVendors, getServiceTypes, getDistricts, getStudents]);

    let amount: any = 0;
    if (valuesForm) {
        amount = valuesForm.amount ? valuesForm.amount : 0;
    }

    let stateAmount = 0;

    const [stateData, setStateData] = useState<any>({});
    Object.keys(stateData).forEach((k: string) => {
        stateAmount += stateData[k].remainingAmount ? +stateData[k].remainingAmount : 0;
    });

    const totalAmount: number = +stateAmount;
    const remainAmount: number = +amount - +totalAmount;

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (!Object.values(stateData).length) {
            toast.error('no applied Invoices!');
            return false;
        }
        if (remainAmount >= 0) {
            handleSubmit(e);
        } else {
            toast.error('Remaining amount needs to be more or equal 0!');
            return false;
        }
    };
    const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(typeEnum);
    const valueCaseType = caseTypes.find((it) => it.value === credit?.caseType);
    const caseTypeObj = valueCaseType ? valueCaseType : {};

    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'CREDITS', path: routes.CREDITS_LIST },
                    { name: `APPLY CREDIT`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {!credit ? (
                    <Loader />
                ) : (
                    <Form
                        students={students}
                        handleSub={handleSub}
                        vendors={vendors}
                        invoices={stateInvoice}
                        providers={providers}
                        amountValue={amount}
                        districts={districts}
                        stateData={stateData}
                        setStateData={setStateData}
                        serviceTypes={serviceTypes}
                        getData={getInvoices}
                        creditCredits={[]}
                        initialValues={{
                            ...credit,
                            creditInvoices: credit?.paymentInvoices,
                            eftInfo: credit?.payment?.eftInfo,
                        }}
                        caseTypeHistory={caseTypeObj}
                        remainAmount={remainAmount}
                        totalAmount={totalAmount}
                    />
                )}
            </div>
        </RoleLayout>
    );
};
export default CreditEditScreen;
